"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteLeaseDocumentMutation = exports.useLazyFetchLeaseDocumentUrlQuery = exports.useUploadLeaseDocumentMutation = exports.useLazyFetchBankSuretyUrlQuery = exports.useFetchBankSuretyUrlQuery = exports.useUploadBankSuretyMutation = exports.useTerminateOccupancyMutation = exports.useUpdateOccupancyMutation = exports.useFetchOccupancyQuery = exports.useSearchOccupanciesQuery = exports.useFetchClientOccupanciesQuery = exports.useCreateOccupancyMutation = exports.occupancyApi = void 0;
// api/occupancyApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.occupancyApi = (0, react_1.createApi)({
    reducerPath: "occupancyApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["occupancies", "bank_surety_url"],
    endpoints: function (builder) { return ({
        createOccupancy: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/occupancy/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["occupancies"],
        }),
        fetchClientOccupancies: builder.query({
            query: function (obj) { return ({
                url: "/v1/occupancy/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    areaId: obj.areaId,
                    buildingId: obj.buildingId,
                    tenantId: obj.tenantId,
                    occupancyType: obj.occupancyType,
                    status: obj.status,
                    deleted: obj.deleted,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["occupancies"],
        }),
        searchOccupancies: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.buildingId)
                    params.buildingId = obj.buildingId;
                if (obj.tenantId)
                    params.tenantId = obj.tenantId;
                if (obj.occupancyType)
                    params.occupancyType = obj.occupancyType;
                if (obj.status)
                    params.status = obj.status;
                return {
                    url: "/v1/occupancy/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["occupancies"],
        }),
        fetchOccupancy: builder.query({
            query: function (occupancyId) { return ({
                url: "/v1/occupancy/fetch",
                method: "GET",
                params: {
                    _id: occupancyId,
                },
            }); },
            providesTags: ["occupancies"],
        }),
        updateOccupancy: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/occupancy/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["occupancies"],
        }),
        terminateOccupancy: builder.mutation({
            query: function (_a) {
                var occupancyId = _a.occupancyId;
                return ({
                    url: "/v1/occupancy/remove?_id=".concat(occupancyId),
                    method: "DELETE",
                });
            },
            invalidatesTags: ["occupancies"],
        }),
        uploadBankSurety: builder.mutation({
            query: function (_a) {
                var occupancyId = _a.occupancyId, formData = _a.formData;
                return ({
                    url: "/v1/occupancy/".concat(occupancyId, "/bank-surety/upload"),
                    method: "POST",
                    body: formData,
                });
            },
            invalidatesTags: ["occupancies", "bank_surety_url"],
        }),
        fetchBankSuretyUrl: builder.query({
            query: function (occupancyId) { return ({
                url: "/v1/occupancy/".concat(occupancyId, "/bank-surety/url"),
                method: "GET",
            }); },
            providesTags: ["bank_surety_url"],
        }),
        // IF-002 §2: multi-document lease uploads.
        uploadLeaseDocument: builder.mutation({
            query: function (_a) {
                var occupancyId = _a.occupancyId, formData = _a.formData;
                return ({ url: "/v1/occupancy/".concat(occupancyId, "/lease-document/upload"), method: "POST", body: formData });
            },
            invalidatesTags: ["occupancies"],
        }),
        fetchLeaseDocumentUrl: builder.query({
            query: function (_a) {
                var occupancyId = _a.occupancyId, docId = _a.docId;
                return ({ url: "/v1/occupancy/".concat(occupancyId, "/lease-document/").concat(docId, "/url"), method: "GET" });
            },
        }),
        deleteLeaseDocument: builder.mutation({
            query: function (_a) {
                var occupancyId = _a.occupancyId, docId = _a.docId;
                return ({ url: "/v1/occupancy/".concat(occupancyId, "/lease-document/").concat(docId), method: "DELETE" });
            },
            invalidatesTags: ["occupancies"],
        }),
    }); },
});
exports.useCreateOccupancyMutation = exports.occupancyApi.useCreateOccupancyMutation, exports.useFetchClientOccupanciesQuery = exports.occupancyApi.useFetchClientOccupanciesQuery, exports.useSearchOccupanciesQuery = exports.occupancyApi.useSearchOccupanciesQuery, exports.useFetchOccupancyQuery = exports.occupancyApi.useFetchOccupancyQuery, exports.useUpdateOccupancyMutation = exports.occupancyApi.useUpdateOccupancyMutation, exports.useTerminateOccupancyMutation = exports.occupancyApi.useTerminateOccupancyMutation, exports.useUploadBankSuretyMutation = exports.occupancyApi.useUploadBankSuretyMutation, exports.useFetchBankSuretyUrlQuery = exports.occupancyApi.useFetchBankSuretyUrlQuery, exports.useLazyFetchBankSuretyUrlQuery = exports.occupancyApi.useLazyFetchBankSuretyUrlQuery, exports.useUploadLeaseDocumentMutation = exports.occupancyApi.useUploadLeaseDocumentMutation, exports.useLazyFetchLeaseDocumentUrlQuery = exports.occupancyApi.useLazyFetchLeaseDocumentUrlQuery, exports.useDeleteLeaseDocumentMutation = exports.occupancyApi.useDeleteLeaseDocumentMutation;
